import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchRuns } from './fetchRuns'

type SaveRunPayload = {
  runs: Record<string, unknown>[]
}

export const saveRuns = createAsyncThunk<void, SaveRunPayload, ThunkApiContext>('runs/saveRun', async ({ runs }: SaveRunPayload, { dispatch }) => {
  await OLMSApiService.post('run/save', runs)

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save run',
    content: `Successfully saved run${runs.length > 1 ? 's' : ''}`,
  }))

  await dispatch(fetchRuns())
})